import { d } from './chunk-6EFRS222.mjs';
import { b } from './chunk-26IU2X5T.mjs';
import { Trigger, Root, List, Item, Link, Content } from '@radix-ui/react-navigation-menu';
import t from 'styled-components';

var a=t(Trigger)`
  width: 100%;
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-large);
  border: none;
  background-color: transparent;

  :hover,
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${b}:first-child {
      color: var(--color-blurple-600);
    }
  }

  &.active {
    ${d} {
      font-weight: var(--font-weight-bold);
    }
  }

  [data-state='open'] {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${b}:first-child {
      color: var(--color-blurple-600);
    }
  }
`;var c={Root:Root,List:List,Item:Item,Link:Link,Trigger:a,Content:Content};

export { c as a };
